import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=26300963"
import script from "./ProductList.vue?vue&type=script&lang=js"
export * from "./ProductList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26300963')) {
      api.createRecord('26300963', component.options)
    } else {
      api.reload('26300963', component.options)
    }
    module.hot.accept("./ProductList.vue?vue&type=template&id=26300963", function () {
      api.rerender('26300963', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/ProductList.vue"
export default component.exports